import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  VIMEO_API,
  VIMEO_API_TOKEN,
  VIMEO_LIVE_CHAT,
  VIMEO_LIVE_CHAT_TOKEN,
} from './constants';
import { VimeoService } from './services/vimeo.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: VIMEO_API_TOKEN,
      useValue: VIMEO_API,
    },
    {
      provide: VIMEO_LIVE_CHAT_TOKEN,
      useValue: VIMEO_LIVE_CHAT,
    },
    VimeoService,
  ],
})
export class DataVimeoModule {}
